export default "__VITE_ASSET__CoZ4hWxJ__"